import { apiConfig } from '../api-config';

export interface SendEmailParams {
  tokenKey: string;
  to: string;
  subject: string;
  message: string;
}

export const sendEmail = (params: any) => {
  apiConfig
    .post('api/TesteEmail/SendEmail', params)
    .then((resp) => resp.data)
    .catch((err) => ({ hasErrors: true, err: err.message }));
};
